import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  query: '',
  locationType: '',
  location: {
    lat: 0,
    lng: 0,
    zoom: 5
  }
}

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setQuery(state, action: PayloadAction<string>) {
      state.query = action.payload
    },
    setLocationType(state, action: PayloadAction<string>) {
      state.locationType = action.payload
    },
    setLocation(state, action: PayloadAction<{ lat: number; lng: number; zoom: number }>) {
      state.location = action.payload
    },
  }
})

export const filterActions = filterSlice.actions
